var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Draggable',{attrs:{"ghostClass":"dragging-row","tag":"tbody","list":_vm.data.subjects,"options":{ animation: 200 },"handle":".drag-handle","disabled":_vm.isUpdating},on:{"change":_vm.onChange}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }